import React, { useEffect, useState } from 'react';
import { MapPin, Package, Users, TrendingUp } from 'lucide-react';
import StatsCard from './StatsCard';
import { getAllLocations } from '../../../services/locations';
import { getAllEquipment } from '../../../services/equipment';
import { getAllTalent } from '../../../services/talent';
import LoadingSpinner from '../../shared/LoadingSpinner';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({
    locations: 0,
    equipment: 0,
    talent: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    setLoading(true);
    
    const [locationsRes, equipmentRes, talentRes] = await Promise.all([
      getAllLocations(),
      getAllEquipment(),
      getAllTalent(),
    ]);

    setStats({
      locations: locationsRes.success ? locationsRes.data.length : 0,
      equipment: equipmentRes.success ? equipmentRes.data.length : 0,
      talent: talentRes.success ? talentRes.data.length : 0,
    });

    setLoading(false);
  };

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Dashboard</h1>
        <p className="dashboard-subtitle">Welcome back! Here's what's happening.</p>
      </div>

      <div className="dashboard-stats">
        <StatsCard
          icon={MapPin}
          title="Total Locations"
          value={stats.locations}
        />
        <StatsCard
          icon={Package}
          title="Equipment Items"
          value={stats.equipment}
        />
        <StatsCard
          icon={Users}
          title="Talent Roster"
          value={stats.talent}
        />
        <StatsCard
          icon={TrendingUp}
          title="Total Items"
          value={stats.locations + stats.equipment + stats.talent}
        />
      </div>

      <div className="dashboard-content">
        <div className="dashboard-card">
          <h2 className="dashboard-card-title">Quick Actions</h2>
          <div className="quick-actions">
            <a href="/admin/locations" className="quick-action-btn">
              <MapPin size={20} />
              <span>Add Location</span>
            </a>
            <a href="/admin/equipment" className="quick-action-btn">
              <Package size={20} />
              <span>Add Equipment</span>
            </a>
            <a href="/admin/talent" className="quick-action-btn">
              <Users size={20} />
              <span>Add Talent</span>
            </a>
          </div>
        </div>

        <div className="dashboard-card">
          <h2 className="dashboard-card-title">Getting Started</h2>
          <div className="getting-started">
            <div className="getting-started-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <h3 className="step-title">Add Your Locations</h3>
                <p className="step-description">
                  Start by adding your filming locations with details, images, and pricing.
                </p>
              </div>
            </div>
            <div className="getting-started-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <h3 className="step-title">Upload Equipment</h3>
                <p className="step-description">
                  Add your equipment inventory with specifications and availability.
                </p>
              </div>
            </div>
            <div className="getting-started-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <h3 className="step-title">Build Talent Roster</h3>
                <p className="step-description">
                  Add talent profiles with portfolios and contact information.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;